<template>
	<div class="dob-wrapper" :class="{ 'has-error': hasError }">
		<formSelect
			class="dob-month half-width"
			v-if="monthFirst"
			:value="selectedMonth"
			@change="updateSelectedMonth"
			:dontLocalize="true"
			:placeHolder="$t('create-account.select-month')"
			:options="monthsList"
			:enterHandler="textFieldEnterHandler"
			:filterable="true"
			:hasError="hasError"
			:labelText="''">
		</formSelect>
		<formSelect
			class="dob-year half-width"
			:class="monthFirst ? 'right-side' : ''"
			:value="selectedYear"
			@change="updateSelectedYear"
			:dontLocalize="true"
			:placeHolder="$t('create-account.select-year')"
			:options="yearsList"
			:enterHandler="textFieldEnterHandler"
			:filterable="true"
			:hasError="hasError"
			:labelText="''">
		</formSelect>
		<formSelect
			class="dob-month half-width"
			:class="!monthFirst ? 'right-side' : ''"
			v-if="!monthFirst"
			:value="selectedMonth"
			@change="updateSelectedMonth"
			:dontLocalize="true"
			:placeHolder="$t('create-account.select-month')"
			:options="monthsList"
			:enterHandler="textFieldEnterHandler"
			:filterable="true"
			:hasError="hasError"
			:labelText="''">
		</formSelect>
		<p v-show="hasError" class="help-block">
			{{ $t('error.input.not-valid-dob') }}
		</p>
	</div>
</template>

<script>

import formSelect from './form-select';

export default {
	name: 'formDate',
	introduction: 'VueJs date selector component',
	components: {
		formSelect
	},
	props: {
		textFieldEnterHandler: {
			type: Function,
			note: 'Keyboard Enter key pressed, handling behavior'
		},
		submitted: {
			type: Boolean,
			default: false,
			note: 'Check submit status'
		},
		monthFirst: {
			type: Boolean,
			default: true,
			note: 'Inline select box order'
		},
		checkCoppa: {
			type: Boolean,
			default: false,
			note: 'Coppa under age checking'
		},
		hasError: {
			type: Boolean,
			default: false,
			note: 'Checking error state'
		},
	},
	data() {
		return {
			internalValueCopy: '',
			// The regular 12 months (string values are + 1 because int months start at 0)
			monthsList: [...Array(12).keys()].map(
				value => ({ label: `${value + 1}`.padStart(2, '0'), value })
			),
			// The past 120 years
			yearsList: [...Array(120).keys()].map(
				value => ({
					label: `${value + (new Date().getFullYear() - 120)}`,
					value: value + (new Date().getFullYear() - 120)
				})
			).reverse(),
			selectedMonth: null,
			selectedYear: null,
		};
	},
	methods: {
		monthAsString(monthInt = this.selectedMonth) {
			return `${monthInt + 1}`.padStart(2, '0');
		},
		updateSelectedMonth(monthInt) {
			this.selectedMonth = monthInt;
			this.emitDateIfComplete();
		},
		updateSelectedYear(yearInt) {
			this.selectedYear = yearInt;
			this.emitDateIfComplete();
		},
		emitDateIfComplete() {
			if (this.selectedMonth !== null && this.selectedYear !== null) {
				this.$emit('input', `${this.selectedYear}${this.monthAsString()}`);
			}
		}
	},
	computed: {
		coppaValid() {
			if (this.selectedMonth === null || this.selectedYear === null) return false;
			// COPPA end date is 13 years after birth
			const coppaEnded = new Date(this.selectedYear + 13, this.selectedMonth);
			return new Date() > coppaEnded;
		},
	},
	watch: {
		selectedMonth() {
			if (this.selectedMonth === null || this.selectedYear === null) {
				this.$emit('validation-change', true);
			} else {
				this.$emit('validation-change', false);
			}
			if (this.checkCoppa) {
				this.$emit('coppa-valid', this.coppaValid);
			}
		},
		selectedYear() {
			if (this.selectedMonth === null || this.selectedYear === null) {
				this.$emit('validation-change', true);
			} else {
				this.$emit('validation-change', false);
			}
			if (this.checkCoppa) {
				this.$emit('coppa-valid', this.coppaValid);
			}
		},
		submitted(modifiedVal) {
			if (modifiedVal !== true) {
				return;
			}
			if (this.selectedMonth === null || this.selectedYear === null) {
				this.$emit('validation-change', true);
			} else {
				this.$emit('validation-change', false);
			}
			if (this.checkCoppa) {
				this.$emit('coppa-valid', this.coppaValid);
			}
		},
	}
};
</script>

<style lang="less" scoped>
	.dob-wrapper {
		margin-bottom: 10px;
		.form-group {
			margin-bottom: 0;
		}
	}
	.half-width {
		width: 49%;
		display: inline-block;
	}
	.right-side {
		float: right;
	}
</style>
